<template>
  <div class="pending-guest">
    <UserIcon class="user-icon" :userId="data.userId" userStatus="dark" />
    <div class="name">
      <span class="name__fullname">{{ data.username }}</span>
    </div>

    <div class="status">wants to join the Room</div>
    <FooterButtons center>
      <btn @onClick="decline" large colour="red"> <template #text>Decline</template></btn>
      <btn @onClick="accept" large colour="green"> <template #text>Accept</template></btn>
    </FooterButtons>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { FooterButtons } from '@/framework';
import UserIcon from '@/components/UserIcon.vue';

export default {
  name: 'PendingGuest',
  components: {
    UserIcon,
    FooterButtons
  },
  computed: {
    ... mapGetters(['guest/room/currentPendingGuest']),
    data() {
      return this['guest/room/currentPendingGuest']
    }
  },
  watch: {
    data(newVal) {
      if (!newVal) {
        this['modal/close']()
      }
    }
  },
  created() {
    this.$emit('modalSettings', {
      styles: {
        'min-width': '350px',
        'max-width': '350px'
      },
      fullScreenOnMobile: false,
      hasCloseButton: true
    });
  },
  methods: {
    ...mapActions(['modal/close', 'cancelPinHandler', 'handleAcceptRoomLobbyGuest', 'handleRejectRoomLobbyGuest']),
    decline() {
      this['modal/close']();
      this.handleRejectRoomLobbyGuest([this.data.locationId, this.data.userId])
    },
    accept() {
      this['modal/close']();
      this.handleAcceptRoomLobbyGuest([this.data.locationId, this.data.userId])
    }
  }
};
</script>
<style scoped lang="scss">
.pending-guest {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user-icon {
  width: 80px;
  height: 80px;
}

.footer-buttons {
  width: 100%;
}

.invitation-response {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.name {
  &__fullname {
    font-size: 1.125rem; /** 18px */
    color: white;
    font-weight: bold;
    margin-right: 8px;
    vertical-align: middle;
  }

  &__pronouns {
    color: $grey-1;
    font-size: 1rem;
    vertical-align: middle;
  }
}

.time {
  font-size: 0.875rem; /** 14px */
  font-weight: bold;
  color: $grey-1;
}

.status {
  margin-top: 20px;
  font-weight: bold;
  font-size: 1.4rem; /** 24px */
  text-align: center;
}
</style>
